import React from "react";
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchField: {
      [theme.breakpoints.down("xs")]: {},
    },
    topZone: {
      [theme.breakpoints.down("xs")]: { width: "100%" },
    },
  })
);

interface BoardSearchiFieldProps {
  setSearchKeyword: any;
  match: any;
  history: any;
}

export default function BoardSearchiField({
  setSearchKeyword,
  match,
  history,
}: BoardSearchiFieldProps) {
  const classes = useStyles();

  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKeyword(event.target.value);
  };

  const keyPress = (e: any) => {
    if (e.keyCode == 13) {
      history.push(`/notice/search/${e.target.value}`);
      // put the login here
    }
  };

  return (
    <div>
      <TextField
        className={classes.topZone}
        onKeyPress={(ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
          }
        }}
        onChange={handleChange}
        onKeyDown={keyPress}
        inputProps={{
          style: {
            // padding: "8px 16px",
            width: "100%",
          },
        }}
        InputLabelProps={
          {
            // style: {
            //   margin: "-8px",
            // },
          }
        }
        id="outlined-basic"
        label="콘텐츠를 찾아보세요"
        variant="outlined"
        size="small"
      />
    </div>
  );
}
